import React, { useState, useEffect } from 'react';
import { dataApi } from "../../apis/dataApi";
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import '../../css/fonts.css'
import '../../css/style.css'
import '../../css/bootstrap@5.3.0.min.css'
import bg from '../../assets/Walpapers/Wallpaper.png';
import kidzos from '../../assets/Iconos/kidzos.png';
import card from '../../assets/Iconos/card.png';
import { useTranslation } from 'react-i18next';
import LogoCam from '../../assets/Logotipo/Logo_cetesninos_color.png';
import { useNavigate } from 'react-router-dom';


function TipoInversion() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [isLoading, setIsLoading] = useState(false);
    const [bracelet, setBracelet] = useState('');
    // Recover querystring 'b' only once on mount
    useEffect(() => {
        setBracelet(searchParams.get('b') || '');
    }, []);

    return (
        <div className="cetes-background" style={{ backgroundImage: `url(${bg})` }}>
            <div className="cetes-background-inner">
                <div className="cetes-junior-header">
                    <div className="info-header-cetes-junior">
                        <div className="text-header-cetes">
                            <h4 className="text-header-mayus">{t('tipoInversion_title')}</h4>
                            <h4>{t('tipoInversion_subtitle')}</h4>
                        </div>
                    </div>
                    <div className="logo_CETES_junior">
                        <div className="logo logo-cetes">
                            <img src={LogoCam} alt="Logo organización KidZania" />
                        </div>
                    </div>
                </div>
                <div className="registro-content">
                    <div className="registro-form-cetes">
                        <div className="registro-form-cetes-inner">

                            <button
                              className="linkBigButton"
                              style={{ border: 'none', background: 'none', padding: 0, width: '100%', textAlign: 'left' }}
                              onClick={() => navigate('/meta?b=' + encodeURIComponent(bracelet) + "&t=e")}
                            >
                                <div style={{ width: '600px' }}>
                                    <p>{t('tipoInversion_opt1')}</p>
                                    <div className="iconBigButton">
                                        <img src={kidzos} style={{ width: "300px" }} />
                                    </div>
                                </div>
                            </button>
                            <button
                              className="linkBigButton"
                              style={{ border: 'none', background: 'none', padding: 0, width: '100%', textAlign: 'left' }}
                              onClick={() => navigate('/registro?b=' + encodeURIComponent(bracelet) + "&t=c")}
                            >
                                <div style={{ width: '600px' }}>
                                    <p>{t('tipoInversion_opt2')}</p>
                                    <div className="iconBigButton">
                                        <img src={card} style={{ width: "200px" }} />
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading ? (
                <div className="loading">
                    <div className="spinner"></div>
                </div>
            ) : (
                <div>
                    {/* Resto del código */}
                </div>
            )}
        </div>
    );
}



export default TipoInversion;